const enToNlDate = (dateString = '') => {
  console.log(dateString);
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};

export default enToNlDate;